import * as Feather from "react-icons/fi";

import { useToken } from "@chakra-ui/react";
import type { FC } from "react";
import type { IconBaseProps, IconType } from "react-icons";

// Import custom icons
import { UsaFlag } from "./icons/UsaFlag";
import { GlobeInternational } from "./icons/GlobeInternational";

// Generic wrapper function
const wrap = (IconComponent: IconType): FC<IconBaseProps> => {
  const WrappedIcon: FC<IconBaseProps> = ({
    size: externalSize = "1em",
    color: externalColor = "currentColor",
    ...props
  }) => {
    const [size] = useToken("sizes", [externalSize]);
    const [color] = useToken("colors", [externalColor]);

    return <IconComponent size={size} color={color} {...props} />;
  };

  return WrappedIcon;
};

export const Icon: Record<string, FC<IconBaseProps>> = {};

for (const [icon, IconComponent] of Object.entries(Feather)) {
  if (typeof IconComponent === "function") {
    const iconName: string = icon.replace(/^Fi/, "");
    Icon[iconName] = wrap(IconComponent);
  }
}

// Add custom icons (these already have token support built-in)
Icon.UsaFlag = UsaFlag;
Icon.GlobeInternational = GlobeInternational;
